module.exports = __webpack_public_path__ + "assets/flag.f28f7528.svg";